module.exports = __webpack_public_path__ + "static/self-design-1-7d063a4b1815d23d9eec254030300554.png";